import { useRef } from 'react';

import { useFormContext } from 'react-hook-form';

import { Button } from '@quick/components/Button';
import { SplitButton } from '@quick/components/SplitButton';

import { useAppTranslation } from '@/app/i18n/client';
import useFormParams from '@/components/demandForm/useFormParams';

import { InlineSpinner } from '../core';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';
import { defaultValues } from './utils';

export const Buttons = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {
    reset,
    watch,
    formState: { isSubmitting },
  } = useFormContext<IForm>();
  const { country_id, data } = useFormDataContext();
  const [{ requote, si }, set] = useFormParams();
  const { t } = useAppTranslation(['demand', 'quotations']);
  const modality = watch('modality_id');
  if (!modality || !data?.lines?.length) return null;

  const isRequoting = si && requote;
  const submitButton = (
    <Button
      type="submit"
      ref={buttonRef}
      disabled={isSubmitting}
      variant="accept"
      className="justify-center"
    >
      {isSubmitting && <InlineSpinner />}
      {isRequoting ? t('quotations:requote') : t('demand:demandForm.getRates')}
    </Button>
  );

  const splitButton = (
    <SplitButton.SplitButton>
      {submitButton}
      <SplitButton.Menu className="z-40" variant="accept">
        <SplitButton.Child
          onClick={async () => {
            await set({ requote: null, firstRequote: null });
            buttonRef.current?.click();
          }}
          variant="accept"
          className="font-semibold"
        >
          {t('quotations:clone')}
        </SplitButton.Child>
      </SplitButton.Menu>
    </SplitButton.SplitButton>
  );

  return (
    <div className="z-10 flex flex-wrap justify-evenly">
      {isRequoting ? splitButton : submitButton}
      <Button
        type="button"
        variant="destruct"
        kind="secondary"
        onClick={async () => {
          await set({
            requote: null,
            firstRequote: null,
            si: null,
            reset: true,
          });

          reset({ ...defaultValues, country_id });
        }}
      >
        {t('demand:demandForm.clean')}
      </Button>
    </div>
  );
};
